/* Hoisted from snippets/sk-ad-slot.liquid (SK perf 2026-09-18): this script used to be inlined once PER PRODUCT CARD
   (30 copies per collection page, ~3.8 KB each x 4 spotlights: spotlight chip/colour controller). It is now loaded once from layout/theme.liquid with defer.
   All init paths (DOMContentLoaded, shopify:section:load, body MutationObserver) are unchanged. */
if (!window._SK_AD_CIP) {
  window._SK_AD_CIP = true;

  var SK_AD_COLORS = {
    'black':'#111111','ink black':'#1c1c2e','jet black':'#0a0a0a',
    'white':'#e8e8e8','off white':'#f0ece4','cream':'#f3ede0',
    'navy':'#0f2557','dark navy':'#0a1a40','blue':'#2563a8','light blue':'#7fb3d3',
    'sky blue':'#87ceeb','royal blue':'#1a4fa0','red':'#c0392b','cherry red':'#b01020',
    'green':'#2e7d32','olive':'#6b7c3b','forest green':'#228b22','sage':'#8fad88',
    'grey':'#777777','gray':'#777777','charcoal':'#3c3c3c','heather grey':'#9a9a9a',
    'light grey':'#c0c0c0','brown':'#6d4c41','tan':'#c8a87a','camel':'#c19a6b',
    'pink':'#d06080','hot pink':'#e91e8c','blush':'#e8b4b8','mauve':'#b07080',
    'purple':'#7b3fa0','lavender':'#9b8bb0','violet':'#6a0dad','plum':'#8e3c8e',
    'orange':'#d4660a','rust':'#b84a18','burnt orange':'#c04a10','coral':'#e06050',
    'yellow':'#d4a500','gold':'#c8960a','mustard':'#c8960a','butter':'#e8d080',
    'teal':'#1a8080','turquoise':'#20b0a0','aqua':'#00b0c0','mint':'#88c8a0',
    'burgundy':'#7d1528','wine':'#6d1020','maroon':'#6d0020',
    'beige':'#d4c4a0','sand':'#c8b880','natural':'#d0c4a8',
    'denim':'#4a5c8a','moss':'#7a8a6a','steel':'#6e7e8c','ivory':'#ece5d6'
  };

  function skAdFallback(name) {
    var k = (name || '').toLowerCase().trim();
    if (SK_AD_COLORS[k]) return SK_AD_COLORS[k];
    for (var c in SK_AD_COLORS) {
      if (k.indexOf(c) !== -1 || c.indexOf(k) !== -1) return SK_AD_COLORS[c];
    }
    return '#888888';
  }

  function skAdSlotInit(slot) {
    if (slot._skAdOk) return;
    slot._skAdOk = true;
    var img = slot.querySelector('.sk-ad-slot__media img:not(.sk-ad-slot__lf)');
    var colorsEl = slot.querySelector('.sk-cip__colors');
    if (!colorsEl) return;

    /* Apply fallback color to chips that have no swatch background */
    colorsEl.querySelectorAll('.sk-cip__chip').forEach(function(chip) {
      if (!chip.style.background) chip.style.background = skAdFallback(chip.dataset.v);
    });

    /* Set the initial image to match the pre-selected chip */
    var selChip = colorsEl.querySelector('.sk-cip__chip.is-sel');
    if (img && selChip && selChip.dataset.img) img.src = selChip.dataset.img;

    /* Variant ID input — update when chip changes so the form adds the right variant */
    var vidInput = slot.querySelector('input[ref="variantId"], input[name="id"]');

    /* Click handlers */
    colorsEl.querySelectorAll('.sk-cip__chip').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        colorsEl.querySelectorAll('.sk-cip__chip').forEach(function(b) { b.classList.remove('is-sel'); });
        btn.classList.add('is-sel');
        slot.classList.add('sk-ad-slot--chip-picked');
        if (img && btn.dataset.img) img.src = btn.dataset.img;
        if (vidInput && btn.dataset.vid) vidInput.value = btn.dataset.vid;
      });
    });
  }

  function skAdSlotInitAll() {
    document.querySelectorAll('.sk-ad-slot--product').forEach(skAdSlotInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', skAdSlotInitAll);
  } else {
    skAdSlotInitAll();
  }

  new MutationObserver(function(muts) {
    var found = false;
    muts.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if (n.nodeType !== 1) return;
        if (n.classList && n.classList.contains('sk-ad-slot--product')) { found = true; return; }
        if (n.querySelector && n.querySelector('.sk-ad-slot--product')) found = true;
      });
    });
    if (found) skAdSlotInitAll();
  }).observe(document.body, { childList: true, subtree: true });
}
